import React from 'react';

/**
 * Pagination — paired with usePagination. Deliberately a simple Prev/Next + "Showing A-B of N"
 * rather than a numbered page-list with ellipsis logic; nothing in the app's actual table sizes
 * calls for more than that yet, and it's easy to grow into a numbered variant later if a table
 * genuinely needs one.
 */
interface PaginationProps {
  page: number;
  totalPages: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ page, totalPages, pageSize, totalItems, onPageChange }) => {
  if (totalItems === 0) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 py-2" style={{ borderTop: '1px solid var(--np-border)' }}>
      <span className="np-sub np-tabular">Showing {start}–{end} of {totalItems}</span>
      <div className="d-flex align-items-center gap-2">
        <button type="button" className="np-btn np-btn-ghost np-btn-sm" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
          <i className="ri-arrow-left-s-line"></i>Previous
        </button>
        <span className="np-sub np-tabular">Page {page} of {totalPages}</span>
        <button type="button" className="np-btn np-btn-ghost np-btn-sm" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>
          Next<i className="ri-arrow-right-s-line"></i>
        </button>
      </div>
    </div>
  );
};
